import React from "react";
import PropTypes from "prop-types";
import { FaEdit } from "react-icons/fa";
import CommonModal from "./CommonModal";
import {
  agreementTexts,
  identityText,
  onboardingStepData
} from "../../locales/en";
import Style from "./modal.module.scss";

const AgreementModalId = ({ isOpen, toggle, anatureDataUrl, loading }) => {
  return (
    <CommonModal
      isOpen={isOpen}
      toggle={toggle}
      title={
        <>
          <FaEdit className="me-2" /> {agreementTexts?.modal?.title}
        </>
      }
      modalClassName={`${Style.agreementModal} modal-xl agreementmodal-wrap`}
      headerClassName={`${Style.agreementModalHeader} modal-close-black`}
      bodyClassName={`${Style.agreementModalContent} modal-content embed-responsive embed-responsive-16by9`}
      hideFooter
    >
      {loading ? (
        <div className="spinner-wrap bg-light loaderposition">
          <div className="snipper-wrap">
            <div className="spinner-border custom-spinner-color" />
            <h3>{identityText.onboardingIntgModal.thismayTake}</h3>
          </div>
        </div>
      ) : (
        anatureDataUrl && (
          <iframe
            title={onboardingStepData.agreement}
            id="annatureIframe"
            className="embed-responsive-item"
            src={anatureDataUrl}
            allowFullScreen
          />
        )
      )}
    </CommonModal>
  );
};

AgreementModalId.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  anatureDataUrl: PropTypes.string,
  loading: PropTypes.bool
};

export default AgreementModalId;
